import React from 'react';
import { ICellRendererParams } from '@ag-grid-enterprise/all-modules';
import styled from 'styled-components';
import { useDispatch } from 'react-redux';
import { tabsOpened } from 'store/actions/tabs';
import { IMultiNavigationData } from 'types/navigation';

const MultiNavigationRenderer: React.FC<ICellRendererParams> = (params) => {
  const dispatch = useDispatch();

  // Get navigation data directly from the cell value
  const navigationData: IMultiNavigationData | undefined = params.value;

  if (!navigationData || navigationData.length === 0) return null;

  const handleClick = () => {
    // Group refIds by course
    const courseGroups: Record<number, number[]> = {};

    navigationData.forEach((item) => {
      if (item.courseId >= 0 && item.ref > 0 && item.refId > 0) {
        if (!courseGroups[item.courseId]) {
          courseGroups[item.courseId] = [];
        }
        courseGroups[item.courseId].push(item.refId);
      }
    });

    // Dispatch navigation for each course with all its refIds
    Object.entries(courseGroups).forEach(([courseId, refIds]) => {
      if (refIds.length > 0) {
        // Use the ref from the first item (should be the same for all)
        const ref = navigationData.find((item) => item.courseId === Number(courseId))?.ref;

        if (ref) {
          dispatch(
            tabsOpened({
              refId: ref,
              search: refIds.join(','), // Join multiple refIds with comma
              courseId: Number(courseId),
            }),
          );
        }
      }
    });
  };

  // Check if we have any valid navigation items
  const hasValidItems = navigationData.some((item) => item.ref > 0 && item.refId > 0 && item.courseId >= 0);

  return (
    <LoadIconContainer onClick={hasValidItems ? handleClick : undefined} $clickable={hasValidItems}>
      <i className="fas fa-external-link-alt" />
    </LoadIconContainer>
  );
};

const LoadIconContainer = styled.span<{ $clickable?: boolean }>`
  cursor: ${(props) => (props.$clickable ? 'pointer' : 'default')};
  color: ${(props) => (props.$clickable ? '#1890ff' : '#ccc')};
  transition: color 0.2s ease;

  &:hover {
    color: ${(props) => (props.$clickable ? '#1565c0' : '#ccc')};
  }
`;

export default MultiNavigationRenderer;
